import React, { useState, useEffect } from "react";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import Sidebar from "./sidebar.js";
import Topbar from "./Topbar.js";

const DashboardMain = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [, setActiveSection] = useState("dashboard");
  const [isDesktop, setIsDesktop] = useState(() => window.innerWidth >= 1024);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname.replace("/admin/", "");
    if (path && path !== "admin") setActiveSection(path);
  }, [location]);

  useEffect(() => {
    const handleResize = () => {
      const desktop = window.innerWidth >= 1024;
      setIsDesktop(desktop);
      if (desktop) {
        setSidebarOpen(true); // Always open on desktop
      } else {
        setSidebarOpen(false); // Closed by default on mobile
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const toggleSidebar = () => setSidebarOpen((s) => !s);

  const handleSectionClick = (section) => {
    setActiveSection(section);
    navigate(`/admin/${section}`);
    if (!isDesktop) setSidebarOpen(false);
  };

  const handleLogout = () => {
    localStorage.removeItem("user_id");
    localStorage.removeItem("user_role");
    localStorage.removeItem("user_name");
    navigate("/login");
  };

  return (
    <div className="min-h-screen bg-gray-100 font-[kanit] overflow-x-hidden">
      <Topbar
        onToggleSidebar={toggleSidebar}
        onLogout={handleLogout}
        isDesktop={isDesktop}
      />

      <div className="flex min-w-0">
        {/* DESKTOP SIDEBAR - Always visible on desktop */}
        {isDesktop && (
          <div className="hidden lg:block w-[286px] shrink-0">
            <Sidebar
              isOpen={true}
              toggleSidebar={() => {}} // No toggle needed on desktop
              setActiveSection={handleSectionClick}
              isDesktop={true}
            />
          </div>
        )}

        {/* MOBILE SIDEBAR */}
        <div
          className={[
            "lg:hidden fixed inset-y-0 left-0 z-40",
            "transform transition-transform duration-200 ease-out",
            sidebarOpen ? "translate-x-0" : "-translate-x-full",
          ].join(" ")}
        >
          {/* IMPORTANT: Render Sidebar directly */}
          <Sidebar
            isOpen={sidebarOpen}
            toggleSidebar={toggleSidebar}
            setActiveSection={handleSectionClick}
            isDesktop={false}
          />
        </div>

        {/* MOBILE BACKDROP - Only show when sidebar is open on mobile */}
        {!isDesktop && sidebarOpen && (
          <div
            className="lg:hidden fixed inset-0 z-30 bg-black/40"
            onClick={() => setSidebarOpen(false)}
          />
        )}

        {/* MAIN CONTENT */}
        <main className="flex-1 min-w-0 pt-16">
          <div className="w-full min-w-0 font-[kanit]">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
};

export default DashboardMain;
